

export class EmployeeDetailsSelectByCompanyAndBranchDetailsIdOutputData implements IEmployeeDetailsSelectByCompanyAndBranchDetailsIdOutputData {
    /** The auto-generated id of the employee details master */
    employee_details_id!: number;
    /** The employee first name with 50 character limit */
    first_name!: string;
    /** The employee middle name with 50 character limit */
    middle_name!: string;
    /** The employee last name with 50 character limit */
    last_name!: string;

    constructor(data?: IEmployeeDetailsSelectByCompanyAndBranchDetailsIdOutputData) {
        if (data) {
            for (var property in data) {
                if (data.hasOwnProperty(property))
                    (<any>this)[property] = (<any>data)[property];
            }
        }
    }

    init(_data?: any) {
        if (_data) {
            this.employee_details_id = _data["employee_details_id"];
            this.first_name = _data["first_name"];
            this.middle_name = _data["middle_name"];
            this.last_name = _data["last_name"];
        }
    }

    static fromJS(data: any): EmployeeDetailsSelectByCompanyAndBranchDetailsIdOutputData {
        data = typeof data === 'object' ? data : {};
        let result = new EmployeeDetailsSelectByCompanyAndBranchDetailsIdOutputData();
        result.init(data);
        return result;
    }

    toJSON(data?: any) {
        data = typeof data === 'object' ? data : {};
        data["employee_details_id"] = this.employee_details_id;
        data["first_name"] = this.first_name;
        data["middle_name"] = this.middle_name;
        data["last_name"] = this.last_name;
        return data; 
    }
}

export interface IEmployeeDetailsSelectByCompanyAndBranchDetailsIdOutputData {
    /** The auto-generated id of the employee details master */
    employee_details_id: number;
    /** The employee first name with 50 character limit */
    first_name: string;
    /** The employee middle name with 50 character limit */
    middle_name: string;
    /** The employee last name with 50 character limit */
    last_name: string;
}

